import store from 'store/store';
import { selectUser } from 'store/auth';
import { NODE_ENV } from 'utils/env';

export const _debugger = () => {
  if (NODE_ENV !== 'production') {
    // eslint-disable-next-line
    debugger;
  }
};

export const logger = (...args) => {
  const user = selectUser(store.getState());
  const isStaffUser = /sigob|migob/.test(user?.email || '');
  if (NODE_ENV === 'production' || isStaffUser) {
    // eslint-disable-next-line no-console
  }
};
